<script setup>
import ChangeLogTable from '@/components/Dashboard/ChangeLogs/ChangeLogTable.vue';

const props = defineProps({
  changeLogs: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div class="tile my-4 mx-6">
    <change-log-table :change-logs="changeLogs" :filters="filters" />
  </div>
</template>
